 
// ================== LOGIN/LOGOUT ==================== //
import { Login } from './Login'; 



 
// ================== LIST ==================== //
import { ListDashboard } from './list/ListDashboard'; 
import { ListChamadaDia } from './list/ListChamadaDia'; 
import { ListChamadasProvincia } from './list/ListChamadasProvincia'; 

import { ListDashboardAno } from './list/ListDashboardAno'; 
import { ListChamadasAno } from './list/ListChamadasAno'; 
import { ListChamadasProvinciaAno } from './list/ListChamadasProvinciaAno'; 
import { ListChamada } from './list/ListChamada'; 
import { ListChamadaRegistada } from './list/ListChamadaRegistada'; 
import { ListDashboardChamadaRegistada } from './list/ListDashboardChamadaRegistada'; 
import { ListChamadaPorDia } from './list/ListChamadaPorDia'; 
import { ListChamadaPorAgente } from './list/ListChamadaPorAgente'; 
import { ListHorarioPico } from './list/ListHorarioPico'; 

import { ListMunicipio } from './list/ListMunicipio'; 
import { ListProvincia } from './list/ListProvincia'; 

import { ListInformacao } from './list/ListInformacao'; 
import { ListPacoteInformacao } from './list/ListPacoteInformacao'; 

import { ListSolicitacao } from './list/ListSolicitacao'; 
import { ListPacoteSolicitacao } from './list/ListPacoteSolicitacao'; 

import { ListReclamacao } from './list/ListReclamacao'; 
import { ListPacoteReclamacao } from './list/ListPacoteReclamacao'; 

import { AddChamada } from './list/AddChamada'; 
import { AddIndisponibilidade } from './list/AddIndisponibilidade'; 

import { ListResumoFila } from './list/ListResumoFila'; 
import { ListResumoDaFila } from './list/ListResumoDaFila'; 
import { ListRegistoFila } from './list/ListRegistoFila'; 

import { ChamadaAgente } from './list/ChamadaAgente'; 
import { ListRegistoAgente } from './list/ListRegistoAgente'; 


import { ListDashboardInformacao } from './list/ListDashboardInformacao'; 
import { ListDashboardReclamacao } from './list/ListDashboardReclamacao'; 
import { ListDashboardSolicitacao } from './list/ListDashboardSolicitacao'; 


import { ListMetricas } from './list/ListMetricas'; 
import { ListChamadaRegistadaWhatsApp } from './list/ListChamadaRegistadaWhatsApp'; 
import { ListDashboardChamadaRegistadaWhatsApp } from './list/ListDashboardChamadaRegistadaWhatsApp'; 


import { AddUser } from './list/AddUser'; 
import { ListUser } from './list/ListUser'; 
import { AlterUser } from './list/AlterUser'; 
import { DeleteUser } from './list/DeleteUser'; 


 


const Api = {
AddUser,
ListUser,
AlterUser,
DeleteUser,
ListChamadaRegistadaWhatsApp,

ListDashboardChamadaRegistadaWhatsApp,
  Login, 
  ListDashboard,
  ListChamadaDia,
  ListChamadasProvincia,

  ListDashboardAno,
  ListChamadasAno,
  ListChamadasProvinciaAno,
  ListChamada,
  ListChamadaRegistada,
  ListDashboardChamadaRegistada,
  ListChamadaPorDia,
  ListChamadaPorAgente,
  ListHorarioPico,
  ListMunicipio,
  ListProvincia,
  ListInformacao,
  ListPacoteInformacao,
  ListSolicitacao,
  ListPacoteSolicitacao,
  ListReclamacao,
  ListPacoteReclamacao,
  AddIndisponibilidade,
  AddChamada,

  ListResumoFila,
  ListRegistoFila,
  
  ChamadaAgente,
  ListRegistoAgente,
  ListResumoDaFila,
  ListDashboardSolicitacao,
  ListDashboardReclamacao,
  ListDashboardInformacao,
  ListMetricas,





  
  };


export default Api;